<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">Production Post</span>
  </div>

  <div class="buttons-block">
    <button class="header-button send-button" mat-button (click)="saveDict()" [disabled]="saveLoading"
            [ngClass]="{'disabled-button': saveLoading}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">

    <div class="input-block">
      <div class="input-label">Title</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempPost.name">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Users</div>
      <div class="email-input-text">
        <p-multiSelect
          [options]="users"
          [(ngModel)]="tempPost.userIds"
          optionLabel="name"
          optionValue="id"
          [disabled]="saveLoading"
          placeholder="Select users"
          [style]="{'width': '100%'}"
          display="chip">
        </p-multiSelect>
      </div>
    </div>

    <div class="columns">
        <div class="input-block" [ngClass]="{'full-width': (!tempWeek || !tempWeek?.id)}">
          <div class="input-label">Default capacity</div>

          <div class="email-input-text">
            <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                   [ngModelOptions]="{standalone: true}"
                   [disabled]="saveLoading" [(ngModel)]="tempPost.defaultCapacity">
          </div>
        </div>

        <div class="input-block" *ngIf="tempWeek?.id">
          <div class="input-label">Capacity of {{tempWeek.period}}</div>

          <div class="email-input-text">
            <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                   [ngModelOptions]="{standalone: true}"
                   [disabled]="saveLoading" [(ngModel)]="tempWeek.capacity">
          </div>
        </div>

    </div>
    <div class="columns">
        <div class="input-block" *ngIf="tempWeek?.id">
          <div class="input-label">Average hours per user per day</div>

          <div class="email-input-text">
              <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                     [ngModelOptions]="{standalone: true}"
                     [disabled]="saveLoading" [(ngModel)]="tempPost.averageDurationPerUser">
          </div>
        </div>
        <div class="input-block" *ngIf="tempWeek?.id">
          <div class="input-label">Suggested capacity</div>

          <div class="email-input-text">
              * {{tempPost.userIds.length}} users * 5 days = {{tempPost.averageDurationPerUser * tempPost.userIds.length * 5}} h./week
          </div>
        </div>
    </div>
    <div class="columns">
        <div class="input-block" *ngIf="tempWeek?.id">
          <div class="input-label">Simultaneous jobs</div>

          <div class="email-input-text">
              <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                     [ngModelOptions]="{standalone: true}"
                     [disabled]="saveLoading" [(ngModel)]="tempPost.concurrentJobsQty">
          </div>
        </div>
        <div class="input-block" *ngIf="tempWeek?.id">
          <div class="input-label"></div>

          <div class="email-input-text">
          </div>
        </div>
    </div>
    <ng-container *ngIf="!loadingSpinner">
        <div class="durations-title">Classic Calculations:</div>
        <div class="input-block" *ngFor="let activityForEdit of activitiesForEdit; index as i">
            <app-activity-duration-edit-block [wa]="false" [activity]="activityForEdit" [displayComplexity]="i==0"></app-activity-duration-edit-block>
        </div>
        <div class="durations-title">Workload Calculations:</div>
        <div class="input-block" *ngFor="let activityForEdit of activitiesForEdit; index as i">
            <app-activity-duration-edit-block [wa]="true" [activity]="activityForEdit" [displayComplexity]="i==0"></app-activity-duration-edit-block>
        </div>
    </ng-container>
    <ng-container *ngIf="loadingSpinner">
      <lib-progress-spinner></lib-progress-spinner>
    </ng-container>

  </div>
</div>
